module.exports = __webpack_public_path__ + "static/media/medicationTracker.dc6d8b63.mp3";